import React, { useRef, useState } from "react";
import {
  ArrowDownCircleIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetAllSalesOperations from "./hooks/useGetAllSalesOperations";
import DownloadButton from "../../../../components/DownloadButton";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
//import useGetDigitalAssetsReport from "./hooks/useGetDigitalAssetsReport";

interface SalesOperationsReportProps {}
export const SalesOperationsReport: React.FC<SalesOperationsReportProps> =
  () => {
    const [exportData, setExportData] = useState([]);
    const { data: salesoperations, isLoading: salesoperationsLoading } =
      useGetAllSalesOperations();

    const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
    const history = useHistory();
    const userPermissions = useRecoilValue(permissionsSelector);
    const user = useRecoilValue(accountAtom);

    const tableRef = useRef<any>([]);

    interface ISalesOps {
      officeCode: string;
      officeName: string;
      storeNumber: string;
      glEntityName: string;
      officeType: string;
      address: string;
      city: string;
      state: string;
      zipCode: string;
      salesTypeC: string;
      acquisitionName: string;
      officeClosedDate: string;
      originalOpenedDate: string;
      brandMarketingName: string;
      channelC: string;
      officeOpenedDate: string;
      officeStatusDetails: string;
      officeStatus: string;
      officeDarkReason: string;
      darkReasonEffectiveDate: string;
      officeRelated: string;
      branchManagerName: string;
      districtName: string;
      districtManager: string;
      areaName: string;
      salesVp: string;
      territoryName: string;
      salesPresident: string;
      mondayStoreHours: string;
      tuesdayStoreHours: string;
      wednesdayStoreHours: string;
      thursdayStoreHours: string;
      fridayStoreHours: string;
      saturdayStoreHours: string;
      sundayStoreHours: string;
      phone: string;
    }

    function formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [month, day, year].join("/");
    }

    //For downloading table data
    const mapDataToExport = (data) => {
      setExportData(
        data?.map((salesops: ISalesOps) => {
          return {
            "Office Code": salesops.officeCode,
            "Office Name": salesops.officeName,
            "Corporate Office #": salesops.storeNumber,
            "GL Entity": salesops.glEntityName,
            Type: salesops.officeType,
            Street: salesops.address,
            City: salesops.city,
            State: salesops.state,
            "Zip Code": salesops.zipCode,
            "Sales Type": salesops.salesTypeC,
            "Acquisition Name": salesops.acquisitionName,
            "Office Closed Date": salesops.officeClosedDate
              ? formatDate(salesops.officeClosedDate)
              : "",
            "Original Opened Date": salesops.originalOpenedDate
              ? formatDate(salesops.originalOpenedDate)
              : "",
            Brand: salesops.brandMarketingName,
            Channel: salesops.channelC,
            "Office Opened Date": salesops.officeOpenedDate
              ? formatDate(salesops.officeOpenedDate)
              : "",
            "Office Status Detail": salesops.officeStatusDetails,
            "Office Status": salesops.officeStatus,
            "Dark Status Reason": salesops.officeDarkReason,
            "Dark Status Effective": salesops.darkReasonEffectiveDate
              ? formatDate(salesops.darkReasonEffectiveDate)
              : "",
            "Office Related to Office Status Detail": salesops.officeRelated,
            "Branch Manager": salesops.branchManagerName,
            "Office District": salesops.districtName,
            "Office District Manager": salesops.districtManager,
            "Office Area": salesops.areaName,
            "Office Sales VP": salesops.salesVp,
            "Office Territory": salesops.territoryName,
            "Office Sales President": salesops.salesPresident,
            "Monday Office Hours": salesops.mondayStoreHours,
            "Tuesday Office Hours": salesops.tuesdayStoreHours,
            "Wednesday Office Hours": salesops.wednesdayStoreHours,
            "Thursday Office Hours": salesops.thursdayStoreHours,
            "Friday Office Hours": salesops.fridayStoreHours,
            "Saturday Office Hours": salesops.saturdayStoreHours,
            "Sunday Office Hours": salesops.sundayStoreHours,
            Phone: salesops.phone,
          };
        })
      );
    };

    let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
    const csvReport = {
      filename: "SalesOperationsReport_" + dateTimeToday + ".csv",
      data: exportData,
    };
    const officeColumns = [
      { title: "Office Code", field: "officeCode" },
      {
        title: "Office Name",
        field: "officeName",
        render: (rowData) => {
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                const url = "/officesettings/officesetting";
                history.push({
                  pathname: url,
                  state: {
                    pathname: url,
                    officeCode: rowData?.officeCode,
                    action: "SalesOperationReport",
                  },
                });
                window.location.reload();
                let userTabs = [
                  {
                    to: "",
                  },
                ];
                [...OfficeTabs].forEach((tabs) => {
                  let temp = [...userPermissions].filter(
                    (user) => user === tabs.permission
                  );
                  if (temp.length > 0)
                    userTabs.push({
                      to: tabs.to,
                    });
                });
                userTabs.shift();
                const index = userTabs.findIndex((c) => c.to === url);
                setSelectedIndex(index);
              }}
            >
              <span className="text-quinary  font-bold underline text-sm ">
                {rowData.officeName}
              </span>
            </div>
          );
        },
      },
      { title: "Corporate Office #", field: "storeNumber" },
      { title: "GL Entity", field: "glEntityName" },
      { title: "Type", field: "officeType" },
      { title: "Street", field: "address" },
      { title: "City", field: "city" },
      { title: "State", field: "state" },
      { title: "Zip Code", field: "zipCode" },
      { title: "Sales Type", field: "salesTypeC" },
      { title: "Acquisition Name", field: "acquisitionName" },
      {
        title: "Office Closed Date",
        field: "officeClosedDate",
        render: (rowData) =>
          rowData.officeClosedDate ? formatDate(rowData.officeClosedDate) : "",
      },
      {
        title: "Original Opened Date",
        field: "originalOpenedDate",
        render: (rowData) =>
          rowData.originalOpenedDate
            ? formatDate(rowData.originalOpenedDate)
            : "",
      },
      { title: "Brand", field: "brandMarketingName" },
      { title: "Channel", field: "channelC" },
      {
        title: "Office Opened Date",
        field: "officeOpenedDate",
        render: (rowData) =>
          rowData.officeOpenedDate ? formatDate(rowData.officeOpenedDate) : "",
      },
      { title: "Office Status Detail", field: "officeStatusDetails" },
      { title: "Office Status", field: "officeStatus" },
      { title: "Dark Status Reason", field: "officeDarkReason" },
      {
        title: "Dark Status Effective",
        field: "darkReasonEffectiveDate",
        render: (rowData) =>
          rowData.darkReasonEffectiveDate
            ? formatDate(rowData.darkReasonEffectiveDate)
            : "",
      },
      {
        title: "Office Related to Office Status Detail",
        field: "officeRelated",
      },
      { title: "Branch Manager", field: "branchManagerName" },
      { title: "Office District", field: "districtName" },
      { title: "Office District Manager", field: "districtManager" },
      { title: "Office Area", field: "areaName" },
      { title: "Office Sales VP", field: "salesVp" },
      { title: "Office Territory", field: "territoryName" },
      { title: "Office Sales President", field: "salesPresident" },
      { title: "Monday Office Hours", field: "mondayStoreHours" },
      { title: "Tuesday Office Hours", field: "tuesdayStoreHours" },
      { title: "Wednesday Office Hours", field: "wednesdayStoreHours" },
      { title: "Thursday Office Hours", field: "thursdayStoreHours" },
      { title: "Friday Office Hours", field: "fridayStoreHours" },
      { title: "Saturday Office Hours", field: "saturdayStoreHours" },
      { title: "Sunday Office Hours", field: "sundayStoreHours" },
      { title: "Phone", field: "phone" },
    ];

    return (
      <div className="text-xs items-center">
        <div className="">
          <div className="mx-4 mt-4 overflow-x-auto">
            <div className="flex mb-2 gap-2 items-center">
              <div>
                <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <div className="text-gray-500 text-md font-medium">
                  Report: Accounts
                </div>
                <div className="flex items-center font-bold text-lg text-primary">
                  Sales Operations Report
                </div>
              </div>
            </div>
            <div className="mt-2" />
            <div className="flex justify-between mb-2 mr-2">
              <div className="flex items-center gap-1">
                <span className="text-gray-500 text-sm">Total Records: </span>
                <span className="text-primary text-base font-semibold">
                  {
                    salesoperations?.filter((x) =>
                      user?.isFranchise && user?.isNonFranchise
                        ? true
                        : user?.isFranchise
                        ? x.officeType?.toLowerCase() === "franchise"
                        : x.officeType?.toLowerCase() !== "franchise"
                    ).length
                  }
                </span>
              </div>
              <CSVLink className="" {...csvReport}>
                <DownloadButton
                  buttonValue="Download File"
                  onClick={() =>
                    mapDataToExport(tableRef.current.dataManager.searchedData)
                  }
                  className={undefined}
                  disabled={undefined}
                />
              </CSVLink>
            </div>
          </div>
          <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
            <MaterialTableTS
              data={salesoperations?.filter((x) =>
                user?.isFranchise && user?.isNonFranchise
                  ? true
                  : user?.isFranchise
                  ? x.officeType?.toLowerCase() === "franchise"
                  : x.officeType?.toLowerCase() !== "franchise"
              )}
              isLoading={salesoperationsLoading}
              columns={officeColumns}
              showTitle={false}
              showToolbar={true}
              toolbarSearch={true}
              searchFieldAlignment="left"
              tableRef={tableRef}
            />
          </div>
        </div>
      </div>
    );
  };
